<template>
  <popup
    ref="popupRefs"
    :async="true"
    width="460px"
    title="重置子账户密码"
    confirm-button="保存"
    @confirm="onConfirm"
    @close="onClose"
  >
    <el-form
      ref="formRefs"
      :model="form"
      :rules="rules"
      label-width="100px"
      size="small"
    >
      <el-form-item label="登录账号">
        <span>{{ customer.username }}</span>
      </el-form-item>
      <el-form-item label="新密码" prop="password">
        <el-input
          v-model="form.password"
          show-password
          placeholder="请输入新密码"
        ></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="password_confirm">
        <el-input
          v-model="form.password_confirm"
          show-password
          placeholder="请再次输入新密码"
        ></el-input>
      </el-form-item>
    </el-form>
  </popup>
</template>

<script>
import Popup from "@/components/popup/index.vue";
import { apiResetCustomerPassword } from "@/api/customer-admin";

export default {
  components: {
    Popup,
  },
  data() {
    const passwordConfirmValidator = (rule, value, callback) => {
      if (this.form.password && value !== this.form.password) {
        callback(new Error("两次输入密码不一致"));
        return;
      }
      callback();
    };
    return {
      customer: {},
      form: {
        password: "",
        password_confirm: "",
      },
      rules: {
        password: [
          { required: true, trigger: "blur", message: "请输入新密码" },
          {
            min: 6,
            max: 64,
            trigger: "blur",
            message: "密码长度须在6-64位字符",
          },
        ],
        password_confirm: [
          { required: true, trigger: "blur", message: "请输入确认密码" },
          { validator: passwordConfirmValidator, trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    openDialog(customer) {
      this.customer = customer || {};
      this.$refs.popupRefs.open();
    },
    closeDialog() {
      this.$refs.popupRefs.close();
    },
    onClose() {
      this.$nextTick(() => {
        this.customer = {};
        this.form = {
          password: "",
          password_confirm: "",
        };
        this.$refs.formRefs.clearValidate();
      });
    },
    onConfirm() {
      this.$refs.formRefs.validate((valid) => {
        if (!valid) return;
        apiResetCustomerPassword({
          id: this.customer.id,
          ...this.form,
        }).then(() => {
          this.closeDialog();
          this.$message({
            type: "success",
            message: "重置成功！",
          });
        });
      });
    },
  },
};
</script>
